import { get, post, req } from '@/plugins/axios'

// 商品tiktok分类列表
export function ttsCategories (data?: any) {
  return get('/api/tts/categories', data)
}

// 商品tiktok 地址设置
export function ttsCreatProductCheck (data?: any) {
  return req('/api/tts/creatProductCheck', data)
}

// 设置库存
export function ttsSetSkuStock (data?: any) {
  return req('/api/tts/setSkuStock', data)
}

// 设置库存
export function ttsPploadImage (data?: any) {
  return post('/api/tts/uploadImage', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
